function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// adapted from https://stackoverflow.com/a/40294058
export default function cloneDeep(data) {
  var hash = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new WeakMap();
  if (Object(data) !== data) return data;
  if (hash.has(data)) return hash.get(data);
  var result = data instanceof Date ? new Date(data) : data instanceof RegExp ? new RegExp(data.source, data.flags) : data instanceof Set ? new Set() : data instanceof Map ? new Map() : typeof data.constructor !== 'function' ? Object.create(null) : data.prototype !== void 0 && typeof data.prototype.constructor === 'function' ? data : new data.constructor();

  if (typeof data.constructor === 'function' && typeof data.valueOf === 'function') {
    var val = data.valueOf();

    if (Object(val) !== val) {
      var _result = new data.constructor(val);

      hash.set(data, _result);
      return _result;
    }
  }

  hash.set(data, result);

  if (data instanceof Set) {
    data.forEach(function (val) {
      result.add(cloneDeep(val, hash));
    });
  } else if (data instanceof Map) {
    data.forEach(function (val, key) {
      result.set(key, cloneDeep(val, hash));
    });
  }

  return Object.assign.apply(Object, [result].concat(_toConsumableArray(Object.keys(data).map(function (key) {
    return _defineProperty({}, key, cloneDeep(data[key], hash));
  }))));
}